// redux
export const MODE_SWITCHED = 'app/MODE_SWITCHED';
export const SET_FAILED_VALIDATIONS = 'app/SET_FAILED_VALIDATIONS';
export const GET_CONFIG_SUCCESS = 'app/GET_CONFIG_SUCCESS';
export const GET_CONFIG_FAILURE = 'app/GET_CONFIG_FAILURE';
export const GET_CONFIG_REQUEST = 'app/GET_CONFIG_REQUEST';
export const GET_AUDIENCE_TAGS_SUCCESS = 'app/GET_AUDIENCE_TAGS_SUCCESS';
export const GET_AUDIENCE_TAGS_FAILURE = 'app/GET_AUDIENCE_TAGS_FAILURE';
export const GET_AUDIENCE_TAGS_REQUEST = 'app/GET_AUDIENCE_TAGS_REQUEST';

// TODO refactor modes as a frozen object
export const PAGE_TEMPLATES = 'pages';
export const PAGE_TEMPLATES_CLOSED = 'pages-closed';
export const COMPONENT_TEMPLATE = 'components';
export const COMPONENT_TEMPLATE_CLOSED = 'components-closed';
export const SEARCH_TEMPLATE = 'search';
export const SEARCH_TEMPLATE_CLOSED = 'search-closed';

// TODO refactor status as a frozen object
export const EDIT_STATUS_NONE = 'none';
export const EDIT_STATUS_NEW = 'new';
export const EDIT_STATUS_SAVED = 'saved';
export const EDIT_STATUS_MODIFIED = 'modified';

export const UNSAVED_EDIT_STATUS = [EDIT_STATUS_NEW, EDIT_STATUS_MODIFIED];
